import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  OTP_EMAIL_SUCCESS,
  OTP_EMAIL_FAIL,
  OTP_WA_SUCCESS,
  OTP_WA_FAIL,
  UPDATE_PASSWORD_SUCCESS,
  LOGOUT,
  SET_MESSAGE,
} from "./types";

import AuthService from "src/services/auth.service";
import EventBus from "src/utils/EventBus";
export const register = (fullname, email, wa, password) => (dispatch) => {
  return AuthService.register(fullname, email, wa, password).then(
    (response) => {
      dispatch({
        type: REGISTER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: REGISTER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const login = (email, password, token) => (dispatch) => {
  return AuthService.login(email, password, token).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const otp_email = (email) => (dispatch) => {
  return AuthService.otp_email(email).then(
    (response) => {
      dispatch({
        type: OTP_EMAIL_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: OTP_EMAIL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const otp_wa = (wa) => (dispatch) => {
  return AuthService.otp_wa(wa).then(
    (response) => {
      dispatch({
        type: OTP_WA_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      //console.log(error);
      console.log(error.response.data);

      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.response.data ||
        error.message ||
        error.data.message ||
        error.toString();

      dispatch({
        type: OTP_WA_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const activate_email = (email, kode) => (dispatch) => {
  return AuthService.activate_email(email, kode).then(
    (response) => {
      dispatch({
        type: OTP_WA_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: OTP_WA_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const activate_wa = (wa, kode) => (dispatch) => {
  return AuthService.activate_wa(wa, kode).then(
    (response) => {
      dispatch({
        type: OTP_WA_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: OTP_WA_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const update_password_email = (email, kode, password) => (dispatch) => {
  return AuthService.update_password_email(email, kode, password).then(
    (response) => {
      dispatch({
        type: OTP_WA_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: OTP_WA_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const update_password_wa = (wa, kode, password) => (dispatch) => {
  return AuthService.update_password_wa(wa, kode, password).then(
    (response) => {
      dispatch({
        type: OTP_WA_SUCCESS,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: OTP_WA_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const updatePassword = (uuid, data) => async (dispatch) => {
  try {
    const res = await AuthService.updatePassword(uuid, data);

    dispatch({
      type: UPDATE_PASSWORD_SUCCESS,
      payload: data,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    //if (err.response && err.response.status === 401) {
    //EventBus.dispatch("logout");
    //}
    return Promise.reject(err);
  }
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};
